export default __webpack_public_path__ + "bml-intro-video2a6e7e.png";